import React, { useContext, useEffect } from "react";
import "./Blog.css";
import "./ResponsiveBlog.css";
import Fade from "react-reveal/Fade";
import Aos from "aos";
import { motion, Variants } from "framer-motion";
import { dataContext } from "../../context/DataContextProvider";
import { Link, useNavigate, useParams } from "react-router-dom";
// import AliceCarousel from "react-alice-carousel";
// import "react-alice-carousel/lib/alice-carousel.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Navigation, Pagination,Autoplay } from "swiper/modules";

const imageAnimate = {
  offscreen: { y: -100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    // rotate: [0, 10, 0],
    transition: { type: "spring", bounce: 0.3, duration: 1 },
  },
};

const textAnimate = {
  offscreen: { y: 100, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    // rotate: [0, -50, 0],
    transition: { type: "spring", bounce: 0.3, duration: 1.5 },
  },
};
const Blog = () => {
  const { blogHome, allWebParts } = useContext(dataContext);

  const filterAllWebParts = allWebParts?.filter((x) => x.uniqueName === "blog");
  const filetrKeyIngredient = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };
  useEffect(() => {
    Aos.init();
  }, []);

  // let items = [];
  // if (blogHome && blogHome?.length > 0) {
  //   items = blogHome?.map((item, index) => (
  //     <div
  //       className="box"
  //       data-aos="fade-down"
  //       data-aos-easing="linear"
  //       data-aos-duration="1000"
  //       key={index}
  //     >
  //       <motion.div
  //         initial={"offscreen"}
  //         whileInView={"onscreen"}
  //         viewport={{ once: false, amount: 0.5 }}
  //         transition={{ staggerChildren: 0.5 }}
  //         className="box-content"
  //         // onClick={(()=>navigateHandler(`/blogDetail/${item.id}`))}
  //       >
  //         <motion.div variants={imageAnimate} className="img-blog-container">
  //           <Link to={`/blogDetail/${item.id}`}>
  //             <img
  //               src={`${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=2&imageName=${item.image}`}
  //               alt="Blog1Img.png"
  //             />
  //           </Link>
  //         </motion.div>
  //         <div className="text-blog-container">
  //           <Link to={`/blogDetail/${item.id}`}>
  //             <motion.p variants={textAnimate} className="p-2">
  //               {item.title}
  //             </motion.p>
  //           </Link>
  //           <Link to={`/blogDetail/${item.id}`}>
  //             <motion.p variants={textAnimate} className="p-1">
  //               {item.summary}
  //             </motion.p>
  //           </Link>
  //         </div>
  //       </motion.div>
  //     </div>
  //   ));
  // }

  return (
    <div className="blog" id="blog">
      <div className="content">
        <div className="top-section">
          <h2>{filetrKeyIngredient("blog-h2")?.map((item) => item.Value)}</h2>
          <p>{filetrKeyIngredient("blog-p1")?.map((item) => item.Value)}</p>
          <p>{filetrKeyIngredient("blog-p2")?.map((item) => item.Value)}</p>
        </div>
        <div className="bottom-section">
          {/* <Fade left> */}

          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
          >
            {blogHome?.map((item, index) => (
              <SwiperSlide>
                <div
                  className="box"
                  data-aos="fade-down"
                  data-aos-easing="linear"
                  data-aos-duration="1000"
                  key={index}
                >
                  <motion.div
                    initial={"offscreen"}
                    whileInView={"onscreen"}
                    viewport={{ once: false, amount: 0.5 }}
                    transition={{ staggerChildren: 0.5 }}
                    className="box-content"
                    // onClick={(()=>navigateHandler(`/blogDetail/${item.id}`))}
                  >
                    <motion.div
                      variants={imageAnimate}
                      className="img-blog-container"
                    >
                      <Link to={`/blogDetail/${item.id}`}>
                        <img
                          src={`${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=2&imageName=${item.image}`}
                          alt="Blog1Img.png"
                        />
                      </Link>
                    </motion.div>
                    <div className="text-blog-container">
                      <Link to={`/blogDetail/${item.id}`}>
                        <motion.p variants={textAnimate} className="p-2">
                          {item.title}
                        </motion.p>
                      </Link>
                      <Link to={`/blogDetail/${item.id}`}>
                        <motion.p variants={textAnimate} className="p-1">
                          {item.summary}
                        </motion.p>
                      </Link>
                    </div>
                  </motion.div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* <AliceCarousel
            autoPlay
            autoPlayStrategy="none"
            autoPlayInterval={6000}
            mouseTracking
            infinite
            touchTracking={true}
            disableButtonsControls={true}
            disableDotsControls={items.length < 4}
            responsive={{
              0: { items: 1 },
              1024: {
                items: 3,
              },
            }}
            items={items}
          /> */}

          {/* </Fade> */}
          {/* <Fade top> */}

          {/* </Fade> */}
        </div>
      </div>
    </div>
  );
};

export default Blog;
